import { render, staticRenderFns } from "./SettingsCertificateDialog.vue?vue&type=template&id=39aa384b"
import script from "./SettingsCertificateDialog.vue?vue&type=script&lang=js"
export * from "./SettingsCertificateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports